module.exports = __webpack_public_path__ + "static/media/insulation_gwp_60y_y.296c1775.csv";